(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-list-carousel')) {
    class MulticolumnListCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateDots());
        };

        this.handleDotClick = (event) => {
          this.goTo(Number(event.currentTarget.dataset.index));
        };

        // Theme editor: bring the selected block into view
        this.handleBlockSelect = (event) => {
          const index = this.slides.indexOf(event.target);
          if (index > -1) this.goTo(index, 'auto');
        };

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.updateDots();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.handleScroll);
        this.dots.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        cancelAnimationFrame(this.frame);
      }

      get paddingStart() {
        return parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      }

      goTo(index, behavior = 'smooth') {
        const slide = this.slides[index];
        if (!slide || this.track.scrollWidth <= this.track.clientWidth) return;

        this.track.scrollTo({
          left: slide.offsetLeft - this.paddingStart,
          behavior: this.reducedMotion.matches ? 'auto' : behavior,
        });
      }

      updateDots() {
        if (!this.dots.length) return;

        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        let active = 0;

        if (scrollLeft + clientWidth >= scrollWidth - 2) {
          active = this.slides.length - 1;
        } else {
          let closest = Infinity;
          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - this.paddingStart - scrollLeft);
            if (distance < closest) {
              closest = distance;
              active = index;
            }
          });
        }

        this.dots.forEach((dot, index) => {
          if (index === active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('multicolumn-list-carousel', MulticolumnListCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
